export enum DcdrFlags {
  WEB_ENABLE_VIDEO_CONSUMPTION = 'web-enable-video-consumption',
  WEB_GATING_EXPERIMENT_ENABLE = 'web-gating-experiment-enable',
}
